module.exports = __webpack_public_path__ + "static/media/preta-caveira.5911c931.jpeg";